import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "../common/Nav";
import CareerForm from "../CareerForm";
import Footer from "../common/Footer";
import JoinTeam from "../JoinTeam";
import OpenPosition from "../OpenPosition";

const Career = () => {
  const { pathname } = useLocation();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
      <Nav />
      <div className="overflow-hidden">
        <JoinTeam/>
        <OpenPosition/>
        <CareerForm />
        <Footer />
      </div>
    </div>
  );
};

export default Career;
